import React, { PureComponent } from "react";
import { connect } from "react-redux";
import NavBar from "../components/Navbar/navbar";
import Footer from "../components/Footer";

// 实现默认布局，所有页面加上导航和Footer
class DefaultLayout extends PureComponent {
  render() {
    const { displayFooter, displayHeader } = this.props;

    //可视区域高度，就是一屏的高度
    let clientHeight = displayHeader
      ? window.innerHeight - 94
      : window.innerHeight;

    return (
      <div>
        {displayHeader ? <NavBar/> : ""}
        <div
          style={{ position: "relative"}}
          className="content"
        >
          {this.props.children}
        </div>
        {displayFooter ? <Footer/> : ""}
      </div>
    );
  }
}
export default connect(
    (state) => ({ displayFooter: state.layout.displayFooter,displayHeader:state.layout.displayHeader }),
    {}
  )(DefaultLayout);
